var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3503 20C16.6792 19.076 18.0274 16.8099 17.9996 14.3375C17.957 10.56 14.6002 6.1927 13.0637 4.38919C12.6555 3.91006 11.9134 3.86557 11.4491 4.29883C9.57356 6.04907 5.3466 10.6226 6.08582 15.7107C6.33723 17.4411 7.96046 19.1806 9.5 20C9 18.5 9 18.5 9 18.1037C9 16.5 10.0075 14.5528 11.088 13.338C11.5292 12.8419 12.6542 12.8191 13.0637 13.338C13.9389 14.447 14.897 16.4116 14.916 18.1037C14.9239 18.7974 14.7246 19.46 14.3503 20Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasIcon);
export default __webpack_public_path__ + "static/media/gas-icon.eb6316b1e4ab9558be2ea8b6ff9b80a1.svg";
export { ForwardRef as ReactComponent };